import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute("/_staff/fleets/_layout/alerts")({
  component: () => {
    return <ComingSoonCover />;
  },
});
